import Vue from 'vue'
const methods = {
    toCurrency(value, unsigned = true) {
        if (unsigned) {
            return `$${Math.abs(value).toFixed(2)}`
        } else {
            return value > 0 ? `$${value.toFixed(2)}` : value < 0 ? `-$${Math.abs(value).toFixed(2)}` : '$0'
        }
    },
    toCurrencyWhole(value, unsigned = true) {
        if (unsigned) {
            return `$${Math.abs(value).toFixed(0)}`
        } else {
            return value > 0 ? `$${value.toFixed(0)}` : value < 0 ? `-$${Math.abs(value).toFixed(0)}` : '$0'
        }
    },
    getCurrencyDiff(from, to) {
        const result = from - to,
            sign = result === 0 ? '+' : result > 0 ? '+' : '-'
        return `${sign} $${Math.abs(result).toFixed(0)}`
    },
    getColor(colorName) {
        return {
            none: "",
            white: "bg-white",
            salmon: "bg-salmon",
            blueLightest: "bg-blue-lightest",
            blueLight: "bg-blue-light",
            blue: "bg-blue",
            storm: "bg-storm",
            teal: "bg-teal",
            navyLight: "bg-navy-light",
            navy: "bg-navy",
            navyDark: "bg-navy-dark",
            yellow: "bg-yellow",
            salmonGradient: "bg-gradient-salmon",
            salmonNavyDarkGradient: "bg-gradient-salmon-navy-dark",
            navyDarkSalmonGradient: "bg-gradient-navy-dark-salmon",
            blueGradientLight: "bg-gradient-blue-light",
            blueGradient: "bg-gradient-blue",
            tealGradient: "bg-gradient-teal",
            gray100: "bg-gray-100",
            gray200: "bg-gray-200",
            gray300: "bg-gray-300",
            gray400: "bg-gray-400",
            gray500: "bg-gray-500",
        }[colorName] || ""
    },
    toCamelCase(words) {
        let results = words.split(' ')
        return (results[0].toLowerCase() + results.splice(1).join(''))
    },
    toPascalCase(words) {
        return words.replace(/(\w)(\w*)/g, function(g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); });
    },
    isValidUUID(uuid) {
        return (/^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi).test(uuid)
    },
    isValidCID(cid) { // conversation ID
        return (/^[ESOM]{3}\b-[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi).test(cid)
    },
    /**
     * Push event to dataLayer
     * Parameters:
     * 1) String - Name of the event (e.g., 'begin_checkout', 'add_to_cart')
     * 1) Object - All parameters to include in the event
     */
    pushEvent(eventName, params = {}) {
        // Initialize dataLayer if it doesn't exist
        window.dataLayer = window.dataLayer || [];
        
        // Build event object
        const eventData = {
            'event': 'event_tracking',
            'event_name': eventName,
            'event_type': 'checkout',
            'flow_name': 'checkout',
            ...params
        };
        
        // Push to dataLayer
        window.dataLayer.push(eventData);
    },
    sendEvent(category = 'not set', action = 'not set', label = 'not set', name = null, form = null, value = null, additionalAttributes = {}) {

        const eventAttributes = {
            'event_category': category,
            'event_action': action,
            'event_label': label,
            'event_name': name,
            'form_name': form,
            'event_value': value,
            ...additionalAttributes,
        }

        gtag('event', 'click', eventAttributes)
    },

    checkAvailabilityReporting(status, options = {}) {
        const { 
            responseTime = null, 
            attemptNumber = null,
            requestStartTime = null
        } = options;

        const address = this.$store?.state?.meta || {};
        const calculatedResponseTime = responseTime || 
            (requestStartTime ? new Date().getTime() - requestStartTime : null);

        const fields = {
            'city': address.city || '',
            'state': address.stateOrProvince || '',
            'zip': address.postalCode || '',
            'market': address.marketType || '',
            'dwellingType': address.dwellingType || null,
            'responseTime': calculatedResponseTime,
            'attemptNumber': attemptNumber
        };

        console.log('===== ADDRESS CHECK REPORTING =====');
        console.log('Status:', status);
        console.log('Market:', address.marketType);
        console.log('Dwelling Type:', address.dwellingType);
        console.log('Response Time:', calculatedResponseTime);
        console.log('Attempt Number:', attemptNumber);
        console.log('Address:', {
            city: fields.city,
            state: fields.state,
            zip: fields.zip
        });
        console.log('================================');

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'event_tracking',
            'event_name': 'verify_address',
            'check_avail_status': status,
            'check_avail_state': fields.state,
            'check_avail_zip_code': fields.zip,
            'check_avail_city': fields.city,
            'check_avail_market': fields.market,
            'check_avail_response_time': fields.responseTime,
            'check_avail_dwell_code': fields.dwellingType,
            'check_avail_attempt_number': fields.attemptNumber
        });

        return Promise.resolve();
    },

    businessFormTranslation() {
        console.log('from mixins')
        if (window.location.href.indexOf("/business") > -1) {
            const langToggleBus = document.querySelector(".form-select");
            const busiFirst = document.querySelector("#business-home-form #first_name");
            const busiLast = document.querySelector("#business-home-form #last_name");
            const busiName = document.querySelector("#business-home-form #company_name");
            const busiEmail = document.querySelector("#business-home-form #email");
            const busiPost = document.querySelector("#business-home-form #zip_field");
            const busiComms = document.querySelector("#business-home-form #textAreaField");
            const busiSubmit = document.querySelector("#business-home-form .form-button");


            langToggleBus.addEventListener('change', e => {
                if (e.target.value === 'Español') {
                    busiFirst.setAttribute("placeholder", "Nombre*");
                    busiLast.setAttribute("placeholder", "Apellido*");
                    busiName.setAttribute("placeholder", "Nombre del negocio*");
                    busiEmail.setAttribute("placeholder", "Email*");
                    busiPost.setAttribute("placeholder", "Código postal*");
                    busiComms.setAttribute("placeholder", "Comentarios");
                    busiSubmit.innerHTML = "Enviar"

                } else {
                    busiFirst.setAttribute("placeholder", "First Name*");
                    busiLast.setAttribute("placeholder", "Last Name*");
                    busiName.setAttribute("placeholder", "Business Name*");
                    busiEmail.setAttribute("placeholder", "Email*");
                    busiPost.setAttribute("placeholder", "ZIP Code*");
                    busiComms.setAttribute("placeholder", "Comments");
                    busiSubmit.innerHTML = "Get Started";
                }
            });
            if (document.querySelector('#business-home-form .form-select').value === 'Español') {
                busiFirst.setAttribute("placeholder", "Nombre*");
                busiLast.setAttribute("placeholder", "Apellido*");
                busiName.setAttribute("placeholder", "Nombre del negocio*");
                busiEmail.setAttribute("placeholder", "Email*");
                busiPost.setAttribute("placeholder", "Código postal*");
                busiComms.setAttribute("placeholder", "Comentarios");
                busiSubmit.innerHTML = "Enviar"
            }
        }
    }
}

Vue.mixin({
    methods,
})

export default methods